import { useStoreActions } from '~/contexts';
import { QueryKeys } from '../queryKeys';
import { useQueryState } from '../useQueryState';
export const useDraft = function useDraft() {
    let { draftId, refreshOnHookMount } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { data, isLoading, isBackgroundLoading, isFetching, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.Draft,
            draftId
        ],
        queryFn: ()=>api.draft.getById(draftId),
        enabled: !!draftId,
        refreshOnHookMount
    });
    return {
        draft: data,
        isLoading,
        isBackgroundLoading,
        isFetching,
        error,
        refresh
    };
};
